import { gql } from '@apollo/client'

export const LOOKALIKE_OPTIONS = gql`
    query LookalikeOptions($campaignId: String!, $publisherId: String!, $objective: CampaignObjective!) {
        AudienceHypothesis {
            lookalikeOptions(campaignId: $campaignId, publisherId: $publisherId, objective: $objective) {
                available
                reason
                country
                min_seed_size
                ranges
                seeds {
                    seed_kind
                    label
                    quality_verified
                    status
                    approximate_count_lower
                    eligible
                    message
                }
                account_seeds {
                    account_audience_id
                    label
                    subtype
                    retention_days
                    status
                    approximate_count_lower
                    eligible
                    message
                }
            }
        }
    }
`

export const GENERATE_LOOKALIKE_HYPOTHESES = gql`
    mutation GenerateLookalikeHypotheses(
        $campaignId: String!
        $publisherId: String!
        $objective: CampaignObjective!
        $location: LocationTargeting!
        $seedKind: String
        $accountAudienceId: String
    ) {
        generateLookalikeHypotheses(
            campaignId: $campaignId
            publisherId: $publisherId
            objective: $objective
            location: $location
            seedKind: $seedKind
            accountAudienceId: $accountAudienceId
        ) {
            id
            kind
            label
            audience_id
            audience_mode
            lookalike {
                seed_kind
                seed_label
                account_audience_id
                quality_verified
                ratio
                starting_ratio
                country
            }
        }
    }
`
